import React from "react";
import PropTypes from "prop-types";

function FullBleedHeroIframe({ fields }) {
  const {
    videoUrl = "",
    videoTag = false,
    imageUrl = "",
    imageTag = false,
    heading = "",
    textColor = "",
    asset = {},
  } = fields || {};
  return (
    <div className="overflow-y-auto flex flex-col items-center text-center">
      <div
        className={`w-full h-full aspect-video bg-black relative ${imageTag ? "max-[400px]:aspect-auto mt-[9px]" : ""}`}
      >
        {videoTag ? (
          <video
            className="w-full h-full rounded-lg"
            autoPlay
            muted
            loop
            type="video/mp4"
            src={videoUrl}
          />
        ) : imageTag ? (
          <>
            <img
              className="w-full h-full max-[400px]:max-h-[166px]"
              src={imageUrl || asset?.fields?.file?.url}
              alt={heading}
            />
            <div className="hidden md:flex absolute inset-0 items-center justify-center text-white text-center p-4">
              <div
                className={`${textColor ? `text-${textColor}` : "text-[#000]"} !text-[60px] font-![HelveticaRoman, Helvetica, sans-serif] font-[600] bg-opacity-50 rounded p-2 w-full`}
              >
                {heading}
              </div>
            </div>
          </>
        ) : (
          <iframe
            className="w-full h-full rounded-lg"
            src={
              videoUrl?.includes("watch?v=")
                ? videoUrl.replace("watch?v=", "embed/") + "?rel=0"
                : videoUrl
            }
            title="YouTube video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        )}
      </div>
      {imageTag && (
        <div
          className={`md:hidden bg-[#e5e5e5] p-[20px] text-[#000] text-[34.29px] font-[HelveticaRoman, Helvetica, sans-serif] font-[600] text-center w-full`}
        >
          {heading}
        </div>
      )}
    </div>
  );
}

FullBleedHeroIframe.propTypes = {
  fields: PropTypes.shape({
    videoUrl: PropTypes.string,
    videoTag: PropTypes.bool,
    imageUrl: PropTypes.string,
    imageTag: PropTypes.bool,
    text: PropTypes.string,
  }),
};

FullBleedHeroIframe.defaultProps = {
  fields: {
    videoUrl: "",
    videoTag: false,
    imageUrl: "",
    imageTag: false,
    text: "",
  },
};

export default FullBleedHeroIframe;
